import { _getFromLocalStorage } from './helpers';

const logEvent = ({ eventName, eventData = {} }) => {
  try {
    let cleverTap = window.clevertap;
    eventData.origin_source = 'Retail_PWA';
    cleverTap.event.push(eventName, eventData);
  } catch (error) {
    console.log(error);
  }
};

const onUserLogin = data => {
  try {
    let cleverTap = window.clevertap;

    cleverTap.onUserLogin.push({
      Site: {
        Identity: data.OMSRetailId,

        Phone: `+${
          _getFromLocalStorage('storeDetails').isdCode || '234'
        }${data.Phone.toString().substring(1)}`,
        data,
      },
    });
  } catch (error) {}
};

const onProfileChange = data => {
  try {
    let cleverTap = window.clevertap;
    cleverTap.profile.push({
      Site: {
        Identity: _getFromLocalStorage('omsRetailId'),
        Phone: `+${
          _getFromLocalStorage('storeDetails').isdCode || '234'
        }${_getFromLocalStorage('customerPhone').substring(1)}`,
        data,
      },
    });
  } catch (error) {}
};

export const Analytics = {
  logEvent,
  onUserLogin,
  onProfileChange,
};
